/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Chat_Upload_Unsupported_TypeInputs */



/**
* | output |
* | --- |
* | "Unsupported file type: {name}" |
*
* @param {Chat_Upload_Unsupported_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_upload_unsupported_type = /** @type {((inputs: Chat_Upload_Unsupported_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Upload_Unsupported_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Nicht unterstützter Dateityp: ${i?.name}`)
	return /** @type {LocalizedString} */ (`Unsupported file type: ${i?.name}`)
});